import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { McatalogConfigService } from 'src/app/services/catalogs-services/config-services/mcatalog-config.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-catalogs-config-ticket-templates-card',
  templateUrl: './catalogs-config-ticket-templates-card.component.html',
  styleUrls: ['./catalogs-config-ticket-templates-card.component.scss']
})
export class CatalogsConfigTicketTemplatesCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() tickets;
  @Input() customerTicket;
  @Input() staffTicket;

  basicDataForm = new FormGroup({
    mcatalogTicket: new FormControl({ value: null }, Validators.required),
    staffTicket: new FormControl({ value: null }, Validators.required)
  });
  updateMCatalogTicketsSubscription: Subscription;

  constructor(private mcatalogConfigService: McatalogConfigService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.tickets) {
      this.resetForm();
    }
  }

  public inputChange() {
    if (this.basicDataForm.get('mcatalogTicket').dirty || this.basicDataForm.get('staffTicket').dirty) {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
        this.resetForm();
      }
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateMCatalogTicketsSubscription = this.mcatalogConfigService.updateMCatalogTickets(this.basicDataForm.get('mcatalogTicket').value ? this.basicDataForm.get('mcatalogTicket').value.InternalId : null, this.basicDataForm.get('staffTicket').value ? this.basicDataForm.get('staffTicket').value.InternalId : null).subscribe(
        (res) => {
          this.snackbarService.open(res['message'], 'success');
        },
        (error) => {
          this.snackbarService.open(error['message'], 'error');
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      mcatalogTicket: this.setSelectedTicket(this.customerTicket),
      staffTicket: this.setSelectedTicket(this.staffTicket)
    });
  }

  public validateForm() {
    return true;
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  private setSelectedTicket(t) {
    if (this.tickets && t) {
      for (const ticket of this.tickets) {
        if (ticket.InternalId === t.internalId) {
          return ticket;
        }
      }
    } else {
      return null;
    }
  }

  ngOnDestroy() {
    if (this.updateMCatalogTicketsSubscription) { this.updateMCatalogTicketsSubscription.unsubscribe(); }
  }

}
